import { TaskColumn } from './TaskColumn';
import { IssuesGroup } from './IssuesGroup';
import type { TaskStatus, TaskUI, TasksByStatus } from './types';

interface TaskBoardProps {
  byStatus: TasksByStatus;
  /** Counts pós-filtros (mostrado no header da coluna). */
  totals: Record<TaskStatus, number>;
  /** Counts absolutos do DB (mostrado em "de N" quando difere do filtrado). */
  absoluteTotals: Record<TaskStatus, number>;
  onTaskClick?: (task: TaskUI) => void;
}

export function TaskBoard(props: TaskBoardProps) {
  const { byStatus, totals, absoluteTotals, onTaskClick } = props;
  const showPaused = (absoluteTotals.paused ?? 0) > 0;

  return (
    <div className="flex gap-4 px-2 py-2 overflow-x-auto items-start min-h-[60vh]">
      <TaskColumn
        status="pending"
        tasks={byStatus.pending}
        total={totals.pending}
        absoluteTotal={absoluteTotals.pending}
        onTaskClick={onTaskClick}
      />
      <TaskColumn
        status="running"
        tasks={byStatus.running}
        total={totals.running}
        absoluteTotal={absoluteTotals.running}
        onTaskClick={onTaskClick}
      />
      {showPaused && (
        <TaskColumn
          status="paused"
          tasks={byStatus.paused}
          total={totals.paused}
          absoluteTotal={absoluteTotals.paused}
          onTaskClick={onTaskClick}
        />
      )}
      <TaskColumn
        status="done"
        tasks={byStatus.done}
        total={totals.done}
        absoluteTotal={absoluteTotals.done}
        onTaskClick={onTaskClick}
      />

      <IssuesGroup
        byStatus={byStatus}
        totals={totals}
        absoluteTotals={absoluteTotals}
        onTaskClick={onTaskClick}
      />
    </div>
  );
}
